<template>
  <div class="build">
    <Home v-if="getCurrentSidebarElement==='Home'"/>
    <Itwomen v-if="getCurrentSidebarElement==='ItWomen'"/>
    <About v-if="getCurrentSidebarElement==='About'"/>
    <!-- {{getCurrentSidebarElement}} -->
  
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Home from './Home.vue'
import Itwomen from './ItWomen.vue'
import About from './About.vue'
export default {
  name: 'Build',
  components: {
    Home,
    Itwomen,
    About
  },
  computed:{
    ...mapGetters("menus",["getCurrentSidebarElement"])
  }
}
</script>
<style lang="scss" scoped>
.build{
  padding-top: 3%;
}
</style>
